module.exports = __webpack_public_path__ + "img/sales_white.3a688070.svg";